import React from 'react';
import { useQuery } from '@apollo/client';
import {GET_STORE_CONFIG} from '../../../commonQueries/getBackendConfig';
import readConfig from '../../../utils/readClientConfiguration';
import productionConfiguration from '../../../config/default.json';


const Logo = (props) => {
  const base_media_url = readConfig(productionConfiguration, 'base_media_url');
  let logoUrl = "https://s3.emmezeta.hr/falcon/emmezeta_logo.svg"
  const {data: backendConfig, loading: backendConfigLoading} = useQuery(GET_STORE_CONFIG);

  if (!backendConfigLoading && backendConfig && backendConfig.storeConfig) {
    if (backendConfig.storeConfig.header_logo_src) {
      const configLogoUrl = backendConfig.storeConfig.header_logo_src;
      logoUrl = !configLogoUrl.startsWith('http') ? `${base_media_url}logo/${configLogoUrl}` : configLogoUrl;
    }
  }
  
  return (
    <img src={logoUrl} {...props} alt="Logo"/>
  );
};

export default Logo;